import React from 'react';
import { Navbar, NavbarLink } from '@shared-tracpage/components/navbar';
import { ProfilePageParam } from '@webapp/types/navigation/params';
import { getProfileLinkWithParams } from '@webapp/utils/navigation/profile';
import { motion } from 'framer-motion';
import { Link, useParams } from 'react-router-dom';

const LINKS = [
  {
    label: 'All',
    path: ProfilePageParam.MAIN,
    disabled: false,
  },
  {
    label: 'Music',
    path: ProfilePageParam.MUSIC,
    disabled: false,
  },
  {
    label: 'Merch',
    path: ProfilePageParam.MERCH,
    disabled: false,
  },
  {
    label: 'Collectables',
    path: ProfilePageParam.MAIN,
    disabled: true,
  },
  {
    label: 'Tour',
    path: ProfilePageParam.TOUR,
    disabled: false,
  },
];

const TracpageNavbar = () => {
  const { page } = useParams<{ page: ProfilePageParam }>();

  const isActive = (path: string) => {
    return path.includes(page);
  };

  return (
    <Navbar
      links={LINKS}
      linkRender={(link, i) => (
        <Link
          to={getProfileLinkWithParams(link.path as ProfilePageParam)}
          key={`${link.label}-${i}`}
        >
          <NavbarLink
            className={`${isActive(link.path) ? 'active' : ''} ${
              link.disabled ? 'disabled' : ''
            }`}
          >
            {link.label}
            {isActive(link.path) ? (
              <motion.div className="active-bg" layoutId="active-bg" />
            ) : null}
          </NavbarLink>
        </Link>
      )}
    />
  );
};

export default TracpageNavbar;
